// extracted by mini-css-extract-plugin
module.exports = {"main":"dropdown_main__2eYVO","wrapper":"dropdown_wrapper__5ERb0","trigger":"dropdown_trigger__3ZN9X","dropdownContent":"dropdown_dropdownContent__2UnJs"};